import genLinkParams from '@/lib/generateLinkParams';
import { StyledContent } from '@/components/styles';
import { PartitionCard } from '@/components';
import Swiper from 'react-id-swiper';
import vars from '@/assets/styles/vars'

const PreviewLinks = ({ data, linksType, items, slider,  }) => {
  const params = {
    slidesPerView: 1,
    spaceBetween: 20,
    preloadImages: false,
    resistanceRatio: 0,
    watchOverflow: true,
    keyboard: true,
    speed: 600,
    preventInteractionOnTransition: true,
    updateOnWindowResize: true,
    breakpoints: {
      [vars.breakpoints.lMobile]: {
        slidesPerView: 2,
      },
      [900]: {
        slidesPerView: 3,
      },
      [vars.breakpoints.xsDesktop]: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  }
  return (
    <StyledContent.Cards items={items} slider={slider} type={linksType}>
      {slider ? (
        <Swiper {...params}>
          {data.map((item) => {
            const {
              id,
              title: serviceTitle,
              direction: directionFromProps,
              preview: imageFromProps,
              slug: slug,
              range_price: desc,
              page_type: pageType,
              theme = 'light',
            } = item;

            const type = pageType || linksType || 'service';
            const image = imageFromProps || {};
            const direction = directionFromProps || {};
            const { title: directionTitle, slug: directionSlug } = direction;

            const [href, as] = genLinkParams({
              type,
              parentSlug: directionSlug,
              slug: slug,
            });

            return (
              <PartitionCard
                key={id}
                image={image}
                title={serviceTitle}
                // desc={desc}
                // tag={directionTitle}
                link={{ href, as }}
                cardType="content"
                theme={theme}
              />
            );
          })}
        </Swiper>
      ) : (
        data.map((item) => {
          const {
            id,
            title: serviceTitle,
            direction: directionFromProps,
            preview: imageFromProps,
            preview_mobile,
            slug: slug,
            range_price: desc,
            page_type: pageType,
            theme = 'light',
          } = item;

          const type = pageType || linksType || 'service';
          const image = imageFromProps || {};
          const direction = directionFromProps || {};
          const { title: directionTitle, slug: directionSlug } = direction;

          const [href, as] = genLinkParams({
            type,
            parentSlug: directionSlug,
            slug: slug,
          });

          const link = linksType == 'directions' ? {href: `/services?direction=${slug}`, as: `/services?direction=${slug}`} : { href, as };

          return (
            <PartitionCard
              key={id}
              image={image}
              imageT={preview_mobile}
              title={serviceTitle}
              // desc={desc}
              // tag={directionTitle}
              link={link}
              cardType="content"
              type="service"
              theme={theme}
            />
          );
        })
      )}
    </StyledContent.Cards>
  );
};

export default PreviewLinks;
